<template>
  <div>
    <section id="sub_visual" class="pic09">
      <p>근태관리 소개</p>
      <span>Why ETNERS T&A?</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con09 clear">
        <h6>근무일정은 정교하게,<br/>
          근태현황은 실시간으로 확실하게</h6>
        <span class="ctext1">실시간 직원들의 출퇴근 상황을 확인하고, 주52시간 근로시간 단축법 대응 등 <br/>
      이제 이트너스 T&A 하나면 충분합니다.</span>
        <p class="ctext2 ml0"><span class="cbig">Why</span><span class="pl0">etners T&A?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_33.png" width="104" height="104" alt=""/></p>
              <h6>출퇴근,스마트폰으로 1초만에 끝!</h6>
              <p>직원들은 출퇴근 시 앱에서 터치 한번으로 간편하게 출퇴근체크를 합니다. 나의 근무기록과 일정을 보고 근태 요청을 보낼 수 있습니다.</p>
            <li>
              <p><img src="../../assets/images/c_im_34.png" width="104" height="104" alt=""/></p>
              <h6>믿을 수 있는 출퇴근 기록</h6>
              <p>직원들은 비콘 기기가 있는 사업장 내에서만 출퇴근 체크가 가능하며, 기기는 무상제공됩니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_35.png" width="104" height="104" alt=""/></p>
              <h6>정교한 근무일정 관리</h6>
              <p>다양한 근무 제도에 따른 정교한 근무일정 설계가 가능합니다. 또한 설정한 근무일정을 사용자가 앱에서 자신의 일정을 확인할수 있습니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_36.png" width="104" height="104" alt=""/></p>
              <h6>기업별 맞춤화된 운영환경</h6>
              <p>다양한 기업, 산업군 그리고 근무형태에 적용가능한 기능들을 회사에 맞게 맞춤 설계를 지원합니다. 필요한 운영환경에 맞추어 구축하세요.</p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <!--<div class="btn_area2">
          <button class="k-primary k-button k-big" data-role="button" role="button" aria-disabled="false" tabindex="0">이트너스T&A 웹 관리자 바로가기</button>
        </div>-->
      </section>
    </main>
  </div>
</template>

<script>
  export default {
    name : "etnersconcierge",
    data() {
      return{

      }
    },
    methods:{
      goConcierge:function () {
        this.$router.push({name:'Concierge'})
      }
    }
  }

</script>
